function UserFavorite(){

    return(
        <div>
            <h1> User Favorite will render iframe of individual resource</h1>
            <div> <h1>iframe goes here</h1> </div>
        </div>
    )
}

export default UserFavorite;